import { Form } from 'antd'
import { useCallback, useState } from 'react'

import { INVOICE_TYPES } from '@/consts/billing'
import { useUserStore } from '@/stores/user'
import type { CharityInfo, InvoiceFormValues } from '@/types/billing'
import { validateEmail } from '@/utils/billing'

export function useInvoiceForm() {
  const [invoiceForm] = Form.useForm<InvoiceFormValues>()
  const [invoiceFormValues, setInvoiceFormValues] = useState<InvoiceFormValues>({
    invoiceType: 'electronic',
  })
  const [selectedCharity, setSelectedCharity] = useState<CharityInfo | null>(null)
  const [showCharityModal, setShowCharityModal] = useState(false)

  const userStore = useUserStore()

  const autoFillEmailIfValid = useCallback(() => {
    if (userStore.name && validateEmail(userStore.name) && !invoiceForm.getFieldValue('email')) {
      setTimeout(() => {
        invoiceForm.setFieldsValue({ email: userStore.name })
      }, 0)
    }
  }, [userStore.name, invoiceForm])

  const handleInvoiceTypeChange = useCallback(
    (value: string) => {
      invoiceForm.setFieldValue('invoiceType', value)

      if (
        value === 'electronic' &&
        userStore.name &&
        validateEmail(userStore.name) &&
        !invoiceForm.getFieldValue('email')
      ) {
        invoiceForm.setFieldsValue({ email: userStore.name })
      }
    },
    [invoiceForm, userStore.name],
  )

  const handleCharitySelect = useCallback(
    (charity: CharityInfo) => {
      setSelectedCharity(charity)
      invoiceForm.setFieldsValue({
        charityCode: charity.code,
        charityName: charity.name,
      })
    },
    [invoiceForm],
  )

  const getInitialEmailValue = useCallback(() => {
    return validateEmail(userStore.name) ? userStore.name : ''
  }, [userStore.name])

  return {
    invoiceForm,
    invoiceFormValues,
    setInvoiceFormValues,
    selectedCharity,
    setSelectedCharity,
    showCharityModal,
    setShowCharityModal,
    autoFillEmailIfValid,
    handleInvoiceTypeChange,
    handleCharitySelect,
    getInitialEmailValue,
    invoiceTypes: INVOICE_TYPES,
  }
}
